import {
  Autocomplete,
  FormHelperText,
  TextField,
  IconButton,
  Icon,
} from "@mui/material";
import { t } from "i18next";
import "./BMXAutocomplate.scss";

export default function BMXAutocomplete(props) {
  const {
    meta: { touched, error, submitError },
    input,
    afterIcon,
    afterIconSize,
    afterIconClick,
    disabled,
    options = [],
    renderValue,
    getOptionLabel: customGetOptionLabel,
    renderSecondary,
  } = props;

  const isError = () => !!((error || submitError) && touched);

  const onChange = (event, option) => {
    input.onChange(option);
  };

  const resolveLabel = (option) => {
    if (!option) return "";
    if (typeof option === "string") return option;
    if (customGetOptionLabel) return customGetOptionLabel(option);
    return renderValue ? renderValue(option) : option.label || "";
  };

  const safeValue = input.multiple
    ? Array.isArray(input.value)
      ? input.value
      : []
    : input.value || null;

  return (
    <Autocomplete
      className="BMXAutocomplate"
      data-cy="autocomplete-select"
      {...props}
      options={options}
      multiple={Boolean(input?.multiple)}
      value={safeValue}
      disabled={disabled}
      onChange={onChange}
      disableCloseOnSelect={Boolean(input?.multiple)}
      noOptionsText={t("global:no_values")}
      isOptionEqualToValue={(option, value) =>
        !!value && option?.uuid === value?.uuid
      }
      getOptionLabel={resolveLabel}
      filterOptions={(optionsList, state) => {
        const search = state.inputValue.toLowerCase().trim();
        if (!search) return optionsList;

        return optionsList.filter((option) => {
          const text = resolveLabel(option).toLowerCase();
          return text.includes(search);
        });
      }}
      renderOption={(liProps, option) => (
        <li {...liProps} key={option.uuid || option.label}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            {resolveLabel(option)}
            {renderSecondary && (
              <div style={{ fontSize: "0.8rem", opacity: 0.7 }}>
                {renderSecondary(option)}
              </div>
            )}
          </div>
        </li>
      )}
      renderInput={(params) => (
        <div className="InputArea" style={{ display: "flex", flexDirection: "column" }}>
          {/* Kontener poziomy ze sztywnym wyrównaniem do dolnej krawędzi pola */}
          <div
            className="InputArea"
            style={{
              display: "flex",
              alignItems: "flex-end",
              width: "100%",
            }}
          >
            <TextField
              {...params}
              {...props}
              variant="standard"
              error={isError()}
              style={{ flex: 1 }}
            />

            {afterIcon && (
              <IconButton
                size="small"
                disabled={disabled}
                onClick={afterIconClick}
                disableRipple={!afterIconClick}
                style={{
                  marginBottom: "4px", // wyrównanie idealnie do dolnej kreski TextField
                  padding: 4,
                }}
              >
                <Icon style={{ fontSize: afterIconSize }}>{afterIcon}</Icon>
              </IconButton>
            )}
          </div>

          {/* Błąd renderowany poniżej całego wiersza */}
          {isError() && (
            <FormHelperText error style={{ margin: 0 }}>
              <span className="error text">{error || submitError}</span>
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
